import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import TableCellWrapper from "components/VetExamsTable/TableCellWrapper/TableCellWrapper";
import { EMPTY_STRING } from "common/constants";
import { parseCourseSurfaceForPC, parseDistanceUnit } from "utils/enum-parser";
import ClassOrClaimChange from "./ClassOrClaimChange";

import useStyles from "./styles";

interface IProps {
  race: racehorse360.IUpcomingRace;
  bold: boolean;
  claimChange: number;
  classChange: number;
}

const RaceType = (props: IProps) => {
  const { race, bold = false, claimChange, classChange } = props;
  const DISTANCE_FACTOR = 0.01;

  const classes = useStyles();

  const subClass = race.raceConditions.split(" ")[0];
  const subClassValue = subClass?.length > 1 ? ` - ${subClass}` : EMPTY_STRING;
  const stateBred =
    race.restrictionType === "S" ? " - State Bred" : EMPTY_STRING;
  const claimingPrice = race.maximumClaimPrice
    ? ` - $${race.maximumClaimPrice / 1000}K`
    : EMPTY_STRING;
  const surface = parseCourseSurfaceForPC(race.courseType);
  const distance = race.distance * DISTANCE_FACTOR;
  const distanceUnit = parseDistanceUnit(race.distanceUnit).toUpperCase();
  const shouldShowClassOrClaimChange = [claimChange, classChange].some(Boolean);

  const rowContent = `${race.raceType}${subClassValue}${stateBred}${claimingPrice} - ${surface} - ${distance}${distanceUnit}`;

  return (
    <TableCellWrapper className={classes.root} bold={bold}>
      {`${rowContent} `}
      {shouldShowClassOrClaimChange && (
        <ClassOrClaimChange
          claimChange={claimChange}
          classChange={classChange}
        />
      )}
    </TableCellWrapper>
  );
};

export default React.memo(RaceType);
